import NewsletterForm from './newsletter-form.js';

export default NewsletterForm;
